import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { CurrentTheme } from "theme";
import OnlineStatus from "./online-status/OnlineStatusWithQuery";
import Avatar from "module-common/Avatar";
import LogoutMenu from "./LogoutMenuWithMutation";
import IconMenu from "./IconMenu";

export default class ModuleSideMenu extends Component {
  static propTypes = {
    isSupervisor: PropTypes.bool,
    agent: PropTypes.object,
    config: PropTypes.array,
    onClick: PropTypes.func
  };

  render() {
    return (
      <Wrapper>
        <Logo key="logo" image={CurrentTheme["sidemenu-logo"]} />
        {this.renderMenus()}
      </Wrapper>
    );
  }

  renderMenus = () => {
    const { agent, isSupervisor, config } = this.props;
    const menus = [];
    for (const mod of config) {
      if (mod.restrictSupervisor && !isSupervisor) continue;
      menus.push(
        <NavLink key={mod.path} to={mod.path}>
          <IconMenu
            name={mod.name}
            tooltip={mod.tooltip}
            icon={mod.icon}
            iconSelected={mod.iconSelected}
          />
        </NavLink>
      );
    }
    menus.push(<Spacer key="spacer" />);

    // add agent avatar
    menus.push(
      <OnlineStatus key="agent">
        <IconMenu to="/profile">
          <Avatar
            isSmall
            image={agent && agent.displayPicture}
            status={agent.onlineStatus.onlineStatusType.name}
          />
        </IconMenu>
      </OnlineStatus>
    );
    menus.push(<LogoutMenu key="logout" />);
    return menus;
  };
}

const Wrapper = styled.div`
  display: flex;
  width: 60px;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.sidemenuBackground};
`;
const Spacer = styled.div`
  margin: auto;
`;
const Logo = styled.div`
  width: 60px;
  height: 60px;
  background-size: cover;
  ${props => props.image && `background-image: url(${props.image})`};
`;



// WEBPACK FOOTER //
// ./src/module-sidemenu/ModuleSideMenu.js